import { gridImageSizes, mergeClassNames } from '../../../../utils';

import Image from '../../Image';
import PeopleAndSize from '../../../PeopleAndSize';
import React from 'react';
import RichText from '../../RichText';
import styles from './index.module.scss';

const ObjectFit = {
  contain: 'contain', // Devices
  cover: 'cover', // Workspaces
};

export { ObjectFit };

export default function GridItemMenu({
  objectFit,
  objectPosition = '50% 50%',
  heading,
  description,
  backgroundColor = '#F2F4F5',
  image,
  numberOfSeats = null,
  physicalSizeM2 = null,
  isFocused = false,
  children = null,
  interactionHandler = () => null,
  className = '',
  imageClassname = '',
  contentClassname = '',
}) {
  let showIconRow = Boolean(numberOfSeats) || Boolean(physicalSizeM2);

  return (
    <div
      className={mergeClassNames(
        styles.gridItemMenu,
        isFocused ? styles.isFocused : '',
        showIconRow ? styles.showIconRow : '',
        className
      )}
      onMouseEnter={interactionHandler}
      onMouseLeave={interactionHandler}
      onFocus={interactionHandler}
      onClick={interactionHandler}
    >
      <div className={mergeClassNames(styles.imageContainer, imageClassname)} style={{ backgroundColor }}>
        <div className={styles.imageAnimation}>
          {image?.fluid && (
            <Image
              fluid={gridImageSizes(image.fluid)}
              className={styles.image}
              style={{ objectFit, objectPosition }}
              backgroundColor={backgroundColor}
              eager
              alt={image.description}
            />
          )}
        </div>
      </div>

      <div className={mergeClassNames(styles.contentContainer, contentClassname)}>
        <div className={styles.info}>
          <div className={styles.details}>
            <h5 className={styles.title}>{heading}</h5>
            <PeopleAndSize numberOfSeats={numberOfSeats} physicalSizeM2={physicalSizeM2} />
          </div>
        </div>
        {description && <RichText className={styles.description}>{description}</RichText>}
        {children}
      </div>
    </div>
  );
}
